// extracted by mini-css-extract-plugin
export default {"description":"style_description__JgQKg","inputContainer":"style_inputContainer__8lnaz","buttonsContainer":"style_buttonsContainer__c9qox"};